<template>
  <div class="statistics-index">
    <Tabs :animated="false" v-model="curView">
      <TabPane label="按担保品种统计" name="variety-chart" v-if="permittedTabs.indexOf('variety-chart')>-1">
        <Form ref="statFilterForm" :model="statFilterModel" inline>
          <FormItem prop="cityId" style="width: 200px">
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择地区"></Cascader>
          </FormItem>
          <FormItem prop="industryId" style="width: 200px">
            <Select v-model="statFilterModel.industryId" filterable placeholder="选择专属行业/领域">
              <Option :value="null">不限</Option>
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="guarantorId" v-if="checkRolePermitted(['监管人','总监管人','管理员'])">
            <Select
              v-model="statFilterModel.guarantorId"
              filterable
              remote
              clearable
              @on-select="selectGuarantor"
              placeholder="选择保证人"
              :remote-method="searchGuarantors"
              style="width: 240px"
              :loading="loading">
              <Option v-for="(option, index) in guarantors" :value="option.id" :tag="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <DatePicker type="daterange"
              split-panels
              placeholder="日期区间"
              format="yyyy-MM-dd"
              separator="至"
              @on-change="selectDateRange"
              style="width: 200px">
            </DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="refresh">统计</Button>
          </FormItem>
        </Form>
        <div class="padding-top-20" />
        <Row type="flex" style="justify-items:strech">
          <i-col span="12">
            <div class="variety-chat">
              <div class="variety-range-switcher">
                <i-switch v-model="varietyUndergoingSwitch" size="large">
                  <span slot="open">在保</span>
                  <span slot="close">全部</span>
                </i-switch>
              </div>
              <div id="statByVarietyChart"></div>
            </div>
          </i-col>
          <Divider style="height:auto" type="vertical" />
          <i-col flex="auto">
            <table class="brief-table">
              <thead>
                <tr>
                  <th>类别</th>
                  <th>数量(个)</th>
                  <th>保额(万)</th>
                  <th>保证金(万)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,idx) in varietyStatData" :key="idx">
                  <td class="text-center">{{item.varietyName}}</td>
                  <td class="text-right">{{item.count}}</td>
                  <td class="text-right">{{Math.round(item.amount/10000)/100}}</td>
                  <td class="text-right">{{Math.round(item.deposit/10000)/100}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>合计</th>
                  <th class="text-right">{{varietySumCount}}</th>
                  <th class="text-right">{{Math.round(varietySumAmount/10000)/100}}</th>
                  <th class="text-right">{{Math.round(varietySumDeposit/10000)/100}}</th>
                </tr>
              </tfoot>
            </table>
          </i-col>
        </Row>
        <div class="padding-top-20" />
      </TabPane>
      <TabPane label="按保函状态统计" name="status-chart" v-if="permittedTabs.indexOf('status-chart')>-1">
        <Form ref="statFilterForm" :model="statFilterModel" inline>
          <FormItem prop="cityId" style="width: 200px">
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择地区"></Cascader>
          </FormItem>
          <FormItem prop="industryId" style="width: 200px">
            <Select v-model="statFilterModel.industryId" filterable placeholder="选择专属行业/领域">
              <Option :value="null">不限</Option>
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem prop="guarantorId" v-if="checkRolePermitted(['监管人','总监管人','管理员'])">
            <Select
              v-model="statFilterModel.guarantorId"
              filterable
              remote
              clearable
              @on-select="selectGuarantor"
              placeholder="选择保证人"
              :remote-method="searchGuarantors"
              style="width: 240px"
              :loading="loading">
              <Option v-for="(option, index) in guarantors" :value="option.id" :tag="option.id" :key="index">{{option.name}}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <DatePicker type="daterange"
              split-panels
              placeholder="日期区间"
              format="yyyy-MM-dd"
              separator="至"
              @on-change="selectDateRange"
              style="width: 200px">
            </DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="refresh">统计</Button>
          </FormItem>
        </Form>
        <div class="padding-top-20" />
        <Row type="flex" style="justify-items:strech">
          <i-col span="12">
            <div id="statByStatusChart"></div>
          </i-col>
          <Divider style="height:auto" type="vertical" />
          <i-col flex="auto">
            <table class="brief-table">
              <thead>
                <tr>
                  <th>状态</th>
                  <th>数量(个)</th>
                  <th>保额(万)</th>
                  <th>保证金(万)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,idx) in statusStatData" :key="idx">
                  <td class="text-center">{{item.statusName}}</td>
                  <td class="text-right">{{item.count}}</td>
                  <td class="text-right">{{Math.round(item.amount/10000)/100}}</td>
                  <td class="text-right">{{Math.round(item.deposit/10000)/100}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th>合计</th>
                  <th class="text-right">{{statusSumCount}}</th>
                  <th class="text-right">{{Math.round(statusSumAmount/10000)/100}}</th>
                  <th class="text-right">{{Math.round(statusSumDeposit/10000)/100}}</th>
                </tr>
              </tfoot>
            </table>
          </i-col>
        </Row>
        <div class="padding-top-20" />
      </TabPane>
      <TabPane label="按区域统计" name="city-chart" v-if="permittedTabs.indexOf('city-chart')>-1">
        <div class="padding-top-20" />
        <div id="statByCityChart"></div>
        <div class="padding-top-20" />
        <table class="brief-table">
          <thead>
            <tr>
              <th>地区</th>
              <th>新增数量(个)</th>
              <th>新增保额(万)</th>
              <th>新增保证金(万)</th>
              <th>解除数量(个)</th>
              <th>解除保额(万)</th>
              <th>解除保证金(万)</th>
              <th>在保数量(个)</th>
              <th>在保保额(万)</th>
              <th>在保保证金(万)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in cityStatData" :key="idx">
              <td class="text-center">{{item.cityName}}</td>
              <td class="text-right">{{item.newCount}}</td>
              <td class="text-right">{{Math.round(item.newAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.newDeposit/10000)/100}}</td>
              <td class="text-right">{{item.terminatedCount}}</td>
              <td class="text-right">{{Math.round(item.terminatedAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.terminatedDeposit/10000)/100}}</td>
              <td class="text-right">{{item.undergoingCount}}</td>
              <td class="text-right">{{Math.round(item.undergoingAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.undergoingDeposit/10000)/100}}</td>
            </tr>
          </tbody>
        </table>
        <div class="padding-top-20" />
      </TabPane>
      <TabPane label="按行业/领域统计" name="industry-chart" v-if="permittedTabs.indexOf('industry-chart')>-1">
        <div class="padding-top-20" />
        <div id="statByIndustryChart"></div>
        <div class="padding-top-20" />
        <table class="brief-table">
          <thead>
            <tr>
              <th>行业/领域</th>
              <th>新增数量(个)</th>
              <th>新增保额(万)</th>
              <th>新增保证金(万)</th>
              <th>解除数量(个)</th>
              <th>解除保额(万)</th>
              <th>解除保证金(万)</th>
              <th>在保数量(个)</th>
              <th>在保保额(万)</th>
              <th>在保保证金(万)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in industryStatData" :key="idx">
              <td class="text-center">{{item.industryName}}</td>
              <td class="text-right">{{item.newCount}}</td>
              <td class="text-right">{{Math.round(item.newAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.newDeposit/10000)/100}}</td>
              <td class="text-right">{{item.terminatedCount}}</td>
              <td class="text-right">{{Math.round(item.terminatedAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.terminatedDeposit/10000)/100}}</td>
              <td class="text-right">{{item.undergoingCount}}</td>
              <td class="text-right">{{Math.round(item.undergoingAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.undergoingDeposit/10000)/100}}</td>
            </tr>
          </tbody>
        </table>
        <div class="padding-top-20" />
      </TabPane>
      <TabPane label="按保证人统计" name="guarantor-chart" v-if="permittedTabs.indexOf('guarantor-chart')>-1">
        <div class="padding-top-20" />
        <div id="statByGuarantorChart"></div>
        <div class="padding-top-20" />
        <table class="brief-table">
          <thead>
            <tr>
              <th>保证人</th>
              <th>新增数量(个)</th>
              <th>新增保额(万)</th>
              <th>新增保证金(万)</th>
              <th>解除数量(个)</th>
              <th>解除保额(万)</th>
              <th>解除保证金(万)</th>
              <th>在保数量(个)</th>
              <th>在保保额(万)</th>
              <th>在保保证金(万)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in guarantorStatData" :key="idx">
              <td class="text-center">{{item.guarantorName}}</td>
              <td class="text-right">{{item.newCount}}</td>
              <td class="text-right">{{Math.round(item.newAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.newDeposit/10000)/100}}</td>
              <td class="text-right">{{item.terminatedCount}}</td>
              <td class="text-right">{{Math.round(item.terminatedAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.terminatedDeposit/10000)/100}}</td>
              <td class="text-right">{{item.undergoingCount}}</td>
              <td class="text-right">{{Math.round(item.undergoingAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.undergoingDeposit/10000)/100}}</td>
            </tr>
          </tbody>
        </table>
        <div class="padding-top-20" />
      </TabPane>
      <TabPane label="按日期统计" name="date-chart" v-if="permittedTabs.indexOf('date-chart')>-1">
        <div class="padding-top-20" />
        <div class="stat-unit-type-switcher">
          <i-switch v-model="statFilterModel.statUnitType" :true-value="1" :false-value="0" size="large">
            <span slot="open">按月</span>
            <span slot="close">按日</span>
          </i-switch>
        </div>
        <div id="statByDateChart"></div>
        <div class="padding-top-20" />
        <table class="brief-table">
          <thead>
            <tr>
              <th>日期</th>
              <th>新增数量(个)</th>
              <th>新增保额(万)</th>
              <th>新增保证金(万)</th>
              <th>解除数量(个)</th>
              <th>解除保额(万)</th>
              <th>解除保证金(万)</th>
              <th>在保数量(个)</th>
              <th>在保保额(万)</th>
              <th>在保保证金(万)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,idx) in dateStatData" :key="idx">
              <td class="text-center">{{statFilterModel.statUnitType===0?$moment(`${item.year}-${item.month}-${item.day}`).format('YYYY-MM-DD'):$moment(`${item.year}-${item.month}`).format('YYYY-MM')}}</td>
              <td class="text-right">{{item.newCount}}</td>
              <td class="text-right">{{Math.round(item.newAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.newDeposit/10000)/100}}</td>
              <td class="text-right">{{item.terminatedCount}}</td>
              <td class="text-right">{{Math.round(item.terminatedAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.terminatedDeposit/10000)/100}}</td>
              <td class="text-right">{{item.undergoingCount}}</td>
              <td class="text-right">{{Math.round(item.undergoingAmount/10000)/100}}</td>
              <td class="text-right">{{Math.round(item.undergoingDeposit/10000)/100}}</td>
            </tr>
          </tbody>
        </table>
        <div class="padding-top-20" />
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'Statistics',
  data () {
    return {
      statFilterModel: {
        cityId: null,
        cityIds: null,
        industryId: null,
        guarantorId: null,
        startDate: null,
        endDate: null,
        statUnitType: 0 // 0-每日，1-每月
      },
      cities: [],
      industries: [],
      guarantors: [],
      unitRangeStatData: [],
      varietyUndergoingSwitch: false,
      varietyStatData: [],
      statusStatData: [],
      cityStatData: [],
      industryStatData: [],
      guarantorStatData: [],
      dateStatData: [],
      curView: '',
      permittedTabs: [],
      allTabs: ['variety-chart', 'status-chart', 'city-chart', 'industry-chart', 'guarantor-chart', 'date-chart'],
      guarantorTabs: ['variety-chart', 'status-chart', 'city-chart'],
      supervisorTabs: ['variety-chart', 'status-chart', 'city-chart', 'guarantor-chart', 'date-chart'],
      generalSupervisorTabs: ['variety-chart', 'status-chart', 'city-chart', 'industry-chart', 'guarantor-chart', 'date-chart']
    }
  },
  watch: {
    varietyUndergoingSwitch: function () {
      this.statByVariety()
    },
    curView: function () {
      this.refresh()
    },
    'statFilterModel.statUnitType': function () {
      this.refresh()
    }
  },
  computed: {
    varietySumCount: function () {
      let sum = 0
      this.varietyStatData.forEach(element => {
        sum += element.count
      })
      return sum
    },
    varietySumAmount: function () {
      let sum = 0
      this.varietyStatData.forEach(element => {
        sum += element.amount
      })
      return sum
    },
    varietySumDeposit: function () {
      let sum = 0
      this.varietyStatData.forEach(element => {
        sum += element.deposit
      })
      return sum
    },
    statusSumCount: function () {
      let sum = 0
      this.statusStatData.forEach(element => {
        sum += element.count
      })
      return sum
    },
    statusSumAmount: function () {
      let sum = 0
      this.statusStatData.forEach(element => {
        sum += element.amount
      })
      return sum
    },
    statusSumDeposit: function () {
      let sum = 0
      this.statusStatData.forEach(element => {
        sum += element.deposit
      })
      return sum
    }
  },
  mounted () {
    if (this.$route.params.guarantor && this.$route.params.guarantor.id) {
      this.statFilterModel.guarantorId = this.$route.params.guarantor.id
    }
    switch (this.$store.getters.userInfo.type) {
      case 127:
        this.permittedTabs = this.generalSupervisorTabs
        break
      case 7:
        this.permittedTabs = this.generalSupervisorTabs
        break
      case 5:
        this.permittedTabs = this.supervisorTabs
        break
      case 3:
        this.permittedTabs = this.guarantorTabs
        break
      default:
        this.permittedTabs = []
        break
    }
    this.initCitySelect()
    this.initIndustrySelect()
    this.searchGuarantors()
    // this.statByUnitRange()
    this.curView = 'variety-chart'
  },
  methods: {
    checkRolePermitted (roles) {
      if (this.$store.getters.userInfo.type === 127) {
        return true
      }
      let userRole = this.$common.userType[this.$store.getters.userInfo.type.toString()]
      if (roles instanceof Array) {
        return roles.indexOf(userRole) > -1
      }
      return roles == userRole
    },
    initIndustrySelect () {
      this.$Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    initCitySelect () {
      this.$Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      this.$Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val, selected) {
      console.log(val, selected)
      let lastSelected = selected.length ? selected[selected.length - 1] : null
      if (lastSelected) {
        console.log(lastSelected)
        let cities = []
        let city 
        this.cities.map((c) => {
          if (c.value === lastSelected.value && c.label !== '本级') {
            city = c
          } else {
            if (c.children) {
              c.children.forEach((cl) => {
                if (cl.value === lastSelected.value && cl.label !== '本级') {
                  city = cl
                }
                if (cl.children) {
                  cl.children.forEach(cg => {
                    if (cg.value === lastSelected.value && cg.label !== '本级') {
                      city = cg
                    }
                  })
                }
              })
            }
          }
        })
        console.log(city)
        cities.push(city.value)
        if (city.children) {
          city.children.forEach(cl => {
            cities.push(cl.value)
            if (cl.children) {
              cl.children.forEach(cg => {
                cities.push(cg.value)
              })
            }
          })
        }
        this.statFilterModel.cityIds = cities
      }
      // if (val instanceof Array) {
      //   this.statFilterModel.cityId = val[val.length - 1]
      // } else {
      //   this.statFilterModel.cityId = val
      // }
    },
    selectGuarantor (grtor) {
      this.statFilterModel.guarantorName = grtor.value
    },
    searchGuarantors (query) {
      this.$Api.Guarantor.listGuarantors({
        name: query
      }, 1, 1000).then((grtors) => {
        this.guarantors = grtors.data
      }).catch(err => {
        this.$Message.error('获取保证人列表失败!' + err.message)
      })
    },
    selectDateRange (vals) {
      this.statFilterModel.startDate = vals[0]
      this.statFilterModel.endDate = vals[1]
    },
    refresh () {
      switch (this.curView) {
        case 'variety-chart':
          this.statByVariety()
          break
        case 'status-chart':
          this.statByStatus()
          break
        case 'city-chart':
          this.statByCities()
          break
        case 'industry-chart':
          this.statByIndustries()
          break
        case 'guarantor-chart':
          this.statByGuarantors()
          break
        case 'date-chart':
          this.statByDate()
          break
      }
      // this.statByUnitRange()
    },
    statByUnitRange () {
      this.$Api.Statistics.statByUnitRange({
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        guarantorId: this.statFilterModel.guarantorId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.unitRangeStatData = res
        this.drawStatByStatus()
      }).catch(err => {
        this.$Message.error('获取统计失败!' + err.message)
      })
    },
    statByGuarantors () {
      this.$Api.Statistics.statByGuarantors({
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.guarantorStatData = res
        this.drawStatByGuarantors()
      }).catch(err => {
        this.$Message.error('获取统计失败!' + err.message)
      })
    },
    drawStatByGuarantors () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByGuarantorChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByGuarantorChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按保证人统计', show: false},
          // color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['新增数量', '新增金额', '解除数量', '解除金额', '在保数量', '在保金额'],
            bottom: 0
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: { onZero: true },
              splitLine: { show: false },
              splitArea: { show: false },
              data: this.guarantorStatData.map((v) => {
                return v.guarantorName
              })
            }
          ],
          xAxis: {type:'value'},
          series: [
            {
              name: '新增数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.guarantorStatData.map((v) => {
                return v.newCount
              })
            },
            {
              name: '新增金额',
              type: 'bar',
              stack: 'two',
              data: this.guarantorStatData.map((v) => {
                return Math.round(v.newAmount / 10000) / 100
              })
            },
            {
              name: '解除数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.guarantorStatData.map((v) => {
                return v.terminatedCount
              })
            },
            {
              name: '解除金额',
              type: 'bar',
              stack: 'two',
              data: this.guarantorStatData.map((v) => {
                return Math.round(v.terminatedAmount / 10000) / 100
              })
            },
            {
              name: '在保数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.industryStatData.map((v) => {
                return v.undergoingCount
              })
            },
            {
              name: '在保金额',
              type: 'bar',
              stack: 'two',
              data: this.guarantorStatData.map((v) => {
                return Math.round(v.undergoingAmount / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    },
    statByCities () {
      this.$Api.Statistics.statByCities({
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.cityStatData = res.filter((r) => {
          return r.cityName
        })
        this.drawStatByCities()
      }).catch(err => {
        this.$Message.error('获取统计失败!' + err.message)
      })
    },
    drawStatByCities () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByCityChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByCityChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按业务区域统计', show: false},
          // color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['新增数量', '新增金额', '解除数量', '解除金额', '在保数量', '在保金额'],
            bottom: 0
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: { onZero: true },
              splitLine: { show: false },
              splitArea: { show: false },
              data: this.cityStatData.map((v) => {
                return v.cityName
              })
            }
          ],
          yAxis: {},
          series: [
            {
              name: '新增数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.cityStatData.map((v) => {
                return v.newCount
              })
            },
            {
              name: '新增金额',
              type: 'bar',
              stack: 'two',
              data: this.cityStatData.map((v) => {
                return Math.round(v.newAmount / 10000) / 100
              })
            },
            {
              name: '解除数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.cityStatData.map((v) => {
                return v.terminatedCount
              })
            },
            {
              name: '解除金额',
              type: 'bar',
              stack: 'two',
              data: this.cityStatData.map((v) => {
                return Math.round(v.terminatedAmount / 10000) / 100
              })
            },
            {
              name: '在保数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.cityStatData.map((v) => {
                return v.undergoingCount
              })
            },
            {
              name: '在保金额',
              type: 'bar',
              stack: 'two',
              data: this.cityStatData.map((v) => {
                return Math.round(v.undergoingAmount / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    },
    statByIndustries () {
      this.$Api.Statistics.statByIndustries({
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.industryStatData = res.filter((r) => {
          return r.industryName
        })
        this.drawStatByIndustries()
      }).catch(err => {
        this.$Message.error('获取统计失败!' + err.message)
      })
    },
    drawStatByIndustries () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByIndustryChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByIndustryChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按行业/领域统计', show: false},
          // color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['新增数量', '新增金额', '解除数量', '解除金额', '在保数量', '在保金额'],
            bottom: 0
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          yAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              axisLine: { onZero: true },
              splitLine: { show: false },
              splitArea: { show: false },
              data: this.industryStatData.map((v) => {
                return v.industryName
              })
            }
          ],
          xAxis: {type:'value'},
          series: [
            {
              name: '新增数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.industryStatData.map((v) => {
                return v.newCount
              })
            },
            {
              name: '新增金额',
              type: 'bar',
              stack: 'two',
              data: this.industryStatData.map((v) => {
                return Math.round(v.newAmount / 10000) / 100
              })
            },
            {
              name: '解除数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.industryStatData.map((v) => {
                return v.terminatedCount
              })
            },
            {
              name: '解除金额',
              type: 'bar',
              stack: 'two',
              data: this.industryStatData.map((v) => {
                return Math.round(v.terminatedAmount / 10000) / 100
              })
            },
            {
              name: '在保数量',
              type: 'bar',
              stack: 'one',
              barGap: 0,
              data: this.industryStatData.map((v) => {
                return v.undergoingCount
              })
            },
            {
              name: '在保金额',
              type: 'bar',
              stack: 'two',
              data: this.industryStatData.map((v) => {
                return Math.round(v.undergoingAmount / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    },
    statByDate () {
      this.$Api.Statistics.statByDate({
        statUnitType: this.statFilterModel.statUnitType || 0,
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.dateStatData = res
        this.drawStatDate()
      }).catch(err => {
        this.$Message.error('获取统计失败!' + err.message)
      })
    },
    drawStatDate () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByDateChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByDateChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按日期统计', show: false},
          // color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            }
          },
          legend: {
            data: ['新增数量', '新增金额', '解除数量', '解除金额', '在保数量', '在保金额'],
            top: 0
          },
          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none'
              },
              restore: {},
              saveAsImage: {}
            }
          },
          xAxis: [
            {
              // type: 'time',
              boundaryGap: false,
              // interval: 86400000,
              data: this.dateStatData.map((v) => {
                let format = 'YYYY-MM-DD'
                if (!v.day) {
                  format = 'YYYY-MM'
                  return this.$moment(`${v.year}-${v.month}-01`).format(format)
                } else {
                  return this.$moment(`${v.year}-${v.month}-${v.day}`).format(format)
                }
              })
            }
          ],
          yAxis: [
            {
              name: '数量(个)',
              type: 'value'
            },
            {
              name: '金额(万元)',
              type: 'value'
            }
          ],
          dataZoom: [
            {
              type: 'inside',
              start: 0,
              end: 100
            },
            {
              start: 0,
              end: 100
            }
          ],
          series: [
            {
              name: '新增数量',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 0,
              data: this.dateStatData.map((v) => {
                return v.newCount
              })
            },
            {
              name: '新增金额',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 1,
              data: this.dateStatData.map((v) => {
                return Math.round(v.newAmount / 10000) / 100
              })
            },
            {
              name: '解除数量',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 0,
              data: this.dateStatData.map((v) => {
                return v.terminatedCount
              })
            },
            {
              name: '解除金额',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 1,
              data: this.dateStatData.map((v) => {
                return Math.round(v.terminatedAmount / 10000) / 100
              })
            },
            {
              name: '在保数量',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 0,
              data: this.dateStatData.map((v) => {
                return v.undergoingCount
              })
            },
            {
              name: '在保金额',
              type: 'line',
              // smooth: true,
              // symbol: 'none',
              areaStyle: {},
              yAxisIndex: 1,
              data: this.dateStatData.map((v) => {
                return Math.round(v.undergoingAmount / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    },
    statByVariety () {
      this.$Api.Statistics.statByVarieties({
        statType: this.varietyUndergoingSwitch ? 2 : 1,
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        guarantorId: this.statFilterModel.guarantorId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        if (window.localStorage.getItem('view-mode') === 'migrantworker-only') {
          this.varietyStatData = res.filter((r) => {
            return r.varietyFullName === '建筑务工人员工资支付保证金担保' || r.varietyFullName === '农民工保证金（现金）'
          })
        } else {
          this.varietyStatData = res
        }
        this.drawStatByVariety()
      }).catch(err => {
        this.$Message.error('获取类别统计失败!' + err.message)
      })
    },
    drawStatByVariety () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByVarietyChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByVarietyChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按担保品种统计', show: false},
          color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['保函数量', '担保金额', '现金反担保'],
            bottom: 0
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: this.varietyStatData.map((v) => {
                return v.varietyName
              })
            }
          ],
          yAxis: [
            {
              name: '数量(个)',
              type: 'value'
            },
            {
              name: '金额(万元)',
              type: 'value'
            }
          ],
          series: [
            {
              name: '保函数量',
              type: 'bar',
              barGap: 0,
              data: this.varietyStatData.map((v) => {
                return v.count
              })
            },
            {
              name: '担保金额',
              type: 'bar',
              yAxisIndex: 1,
              data: this.varietyStatData.map((v) => {
                return Math.round(v.amount / 10000) / 100
              })
            },
            {
              name: '现金反担保',
              type: 'bar',
              yAxisIndex: 1,
              data: this.varietyStatData.map((v) => {
                return Math.round(v.deposit / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    },
    statByStatus () {
      this.$Api.Statistics.statByStatus({
        cityId: this.statFilterModel.cityId,
        cityIds: this.statFilterModel.cityIds,
        industryId: this.statFilterModel.industryId,
        guarantorId: this.statFilterModel.guarantorId,
        createTimeStart: this.statFilterModel.startDate,
        createTimeEnd: this.statFilterModel.endDate
      }).then(res => {
        this.statusStatData = res
        this.drawStatByStatus()
      }).catch(err => {
        this.$Message.error('获取状态统计失败!' + err.message)
      })
    },
    drawStatByStatus () {
      let myChart = echarts.getInstanceByDom(document.getElementById('statByStatusChart'))
      if (!myChart) {
        myChart = echarts.init(document.getElementById('statByStatusChart'))
      }
      try {
        myChart.setOption({
          title: {text: '按保函状态统计', show: false},
          color: ['#3d3294', '#006699', '#3098ff'],
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['保函数量', '担保金额', '现金反担保'],
            bottom: 0
          },
          toolbox: {
            show: true,
            feature: {
              mark: {show: true},
              dataView: {show: true, readOnly: false},
              magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
              restore: {show: true},
              saveAsImage: {show: true}
            }
          },
          xAxis: [
            {
              type: 'category',
              axisTick: {show: false},
              data: this.statusStatData.map((v) => {
                return v.statusName
              })
            }
          ],
          yAxis: [
            {
              name: '数量(个)',
              type: 'value'
            },
            {
              name: '金额(万元)',
              type: 'value'
            }
          ],
          series: [
            {
              name: '保函数量',
              type: 'bar',
              barGap: 0,
              data: this.statusStatData.map((v) => {
                return v.count
              })
            },
            {
              name: '担保金额',
              type: 'bar',
              yAxisIndex: 1,
              data: this.statusStatData.map((v) => {
                return Math.round(v.amount / 10000) / 100
              })
            },
            {
              name: '现金反担保',
              type: 'bar',
              yAxisIndex: 1,
              data: this.statusStatData.map((v) => {
                return Math.round(v.deposit / 10000) / 100
              })
            }
          ]
        }, true)
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
#statByVarietyChart {
  min-height: 400px;
}
#statByStatusChart {
  height: 400px;
}
#statByCityChart {
  min-height: 400px;
}
#statByIndustryChart {
  min-height: 400px;
}
#statByGuarantorChart {
  min-height: 400px;
}
#statByDateChart {
  min-height: 400px;
}
.variety-chat {
  position: relative;
  .variety-range-switcher {
    position: absolute;
    right: 15px;
    bottom: 0px;
    z-index: 500;
  }
}
</style>